'use strict';

import Type from './Type';

/**
 * @property {string}  caption
 * @property {boolean} deprecated
 * @property {string}  deprecationNotice
 * @property {string}  description
 * @property {string}  example
 * @property {boolean} hidden
 * @property {boolean} internal
 * @property {string}  minimumVersion
 * @property {string}  name
 * @property {Type[]}  types
 * @property {Type}    type
 * @property {boolean} readOnly
 */
class TypeProperty {
  /**
   * @param {string}  name
   * @param {string}  caption
   * @param {string}  description
   * @param {boolean} deprecated
   * @param {string}  deprecationNotice
   * @param {string}  example
   * @param {boolean} hidden
   * @param {boolean} internal
   * @param {string}  minimumVersion
   * @param {Type[]}  types
   * @param {Type}    type
   * @param {boolean} readOnly
   */
  constructor ( name, {
    caption,
    description,
    deprecated,
    deprecationNotice,
    example,
    hidden,
    internal,
    minimumVersion,
    readOnly,
    types,
  }, type ) {
    this.name              = name;
    this.type              = type;
    this.caption           = caption;
    this.deprecated        = deprecated;
    this.deprecationNotice = deprecationNotice;
    this.description       = description;
    this.example           = example;
    this.hidden            = hidden;
    this.internal          = internal;
    this.minimumVersion    = minimumVersion;
    this.types             = Object.entries(types).map(( [ name, data ] ) => new Type(name, data, this.type.api));
    this.readOnly          = readOnly;
  }

  /**
   * Returns the type string
   *
   * @returns {string}
   */
  toString () {
    return this.name;
  }
}

export default TypeProperty;
